import React, { Component } from 'react';
import { Pager } from './parts/Pager';
import { Loading } from './parts/Loading';
import * as axios from 'axios';
import lightbox  from "./LightBoxEnable";

function InfoArticle(props) {
  const date = props.article.date.split('T')[0].replace('/-/g', '/');
  return (
    <div className="info-article">
      <div className='info-article-header clearfix'>
        <div className='info-article-date'>{date}</div>
        <div className='info-article-title'>{props.article.title}</div>
      </div>
      <div className='info-article-content'
           dangerouslySetInnerHTML={{__html: props.article.content}}/>
    </div>
  )
}

class InfoComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cur_page: 0,
      articles: [],
      loading_done: false
    };
  }

  loadInfo() {
    let articles = [];

    function callApi(page) {
      const params = {
        'page': page,
        'filter[posts_per_page]': 10,
        'filter[category_name]': 'info'
      };

      axios.get('//midori-frauen.com/wp-json/posts', {params: params})
        .then(resp => {
          articles = articles.concat(resp.data);
          if(resp.data.length === 10) {
            callApi.bind(this)(page + 1);
          } else {
            this.setState({articles: articles});
          }
        })
    }
    callApi.bind(this)(1);
  }

  componentDidMount() {
    this.loadInfo();
  }

  render() {

    const itemPerPage = 5;
    const curPage = parseInt(this.props.match.params.page, 10);

    const _from = (curPage - 1) * itemPerPage;
    const _to = _from + itemPerPage;

    const displayArticles = this.state.articles.slice(_from, _to);
    const totalPage = Math.ceil(this.state.articles.length / itemPerPage);

    const InfoArticlesNode = displayArticles.map((article, i) => {
      return <InfoArticle article={article} key={i}/>
    });

    return (
      <div className="content">
        {this.state.articles.length === 0
          ?
          <Loading/>
          :
          <div className="info-article-wrapper">
            <div className="info-article-list">
              {InfoArticlesNode}
            </div>
            <div className="info-article-pager">
              <Pager base_url={'/info'} total={totalPage} current={curPage}/>
            </div>
          </div>
        }
      </div>
    )
  }
}

export const Info = lightbox(InfoComp);


// WEBPACK FOOTER //
// ./src/components/Info.jsx